import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, ColorTypes } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { LateralBar } from '../../../../components/LateralBar';

interface MobileAssetSelectedProps {
  children: React.ReactNode;
  productColor: ColorTypes.Option;
  handleEditProduct: () => void;
}

export const MobileAssetSelected: React.FC<MobileAssetSelectedProps> = ({
  children,
  productColor,
  handleEditProduct,
}) => {
  return (
    <VStack mx="inline.xxxs" space="1px">
      <HStack
        alignItems="center"
        justifyContent="space-between"
        p="inline.xxxs"
        bg="neutral.white"
        borderTopRadius={BoxRadius.sm}>
        <UI.Text variant="semibold" color="neutral.black">
          Produto selecionado
        </UI.Text>
        <UI.Badge
          testId="badge-product"
          backgroundColor="feedback.success.default"
          textColor="neutral.white">
          Concluído
        </UI.Badge>
      </HStack>
      <VStack
        mt={0.5}
        px="inline.xxxs"
        pb="inline.xxxs"
        borderBottomRadius={BoxRadius.sm}
        space="inline.xxxs"
        bg="neutral.white">
        <LateralBar barColor={productColor} borderBottomLeftRadius={BoxRadius.sm} />
        {children}
        <Pressable w="full" onPress={handleEditProduct}>
          <HStack alignItems="center" justifyContent="space-between" w="full">
            <UI.Text color="brand.tertiary.principal" variant="semibold" textTransform="uppercase">
              Trocar produto
            </UI.Text>
            <UI.Icon name="Reverse" size="xxs" color="brand.tertiary.principal" />
          </HStack>
        </Pressable>
      </VStack>
    </VStack>
  );
};
